import { render } from "./UploadDocumentModalDialog.vue?vue&type=template&id=36b70d16&scoped=true&ts=true&lang=pug"
import script from "./UploadDocumentModalDialog.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentModalDialog.vue?vue&type=script&lang=ts"

import "./UploadDocumentModalDialog.vue?vue&type=style&index=0&id=36b70d16&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b70d16"]])

export default __exports__